/**
 * Chia số kiện của đơn theo 3 cỡ túi (Quân chốt giá 3 cỡ 13/10/2026).
 *
 * Nhãn lấy theo backend `services/staticContent/bagSizeConfigService.js`:
 * small = "Small bag", medium = "Standard suitcase", large = "Oversized".
 * Ở bảng/chi tiết đơn dùng bản rút gọn Small / Standard / Oversized.
 *
 * Đơn cũ không có bagsSmall/bagsMedium/bagsLarge (null) ⇒ toàn bộ là cỡ chuẩn,
 * hàm trả null để màn hình hiện y như trước (chỉ con số quantity).
 */
export type BagSizeCounts = {
	quantity?: number | null;
	bagsSmall?: number | null;
	bagsMedium?: number | null;
	bagsLarge?: number | null;
};

export const BAG_SIZE_SHORT_LABELS = {
	small: "Small",
	medium: "Standard",
	large: "Oversized",
} as const;

function toCount(v: unknown): number | null {
	if (v === null || v === undefined || v === "") return null;
	const n = Number(v);
	return Number.isFinite(n) && n >= 0 ? Math.floor(n) : null;
}

/** "1 Small · 1 Standard" — null khi đơn không có dữ liệu theo cỡ. */
export function formatBagSizeBreakdown(order?: BagSizeCounts | null): string | null {
	if (!order) return null;
	const small = toCount(order.bagsSmall);
	const medium = toCount(order.bagsMedium);
	const large = toCount(order.bagsLarge);
	if (small === null && medium === null && large === null) return null;
	const parts: string[] = [];
	if (small) parts.push(`${small} ${BAG_SIZE_SHORT_LABELS.small}`);
	if (medium) parts.push(`${medium} ${BAG_SIZE_SHORT_LABELS.medium}`);
	if (large) parts.push(`${large} ${BAG_SIZE_SHORT_LABELS.large}`);
	return parts.length > 0 ? parts.join(" · ") : null;
}

/** "2 (1 Small · 1 Standard)" hoặc "2" khi không có dữ liệu theo cỡ. */
export function formatQuantityWithBagSizes(order?: BagSizeCounts | null): string {
	const q = order?.quantity;
	const base = q === null || q === undefined ? "" : String(q);
	const breakdown = formatBagSizeBreakdown(order);
	if (!breakdown) return base;
	return base ? `${base} (${breakdown})` : breakdown;
}
